import React from 'react';
import styled, { css } from 'styled-components';

import CompareButtonComponent from '@/components/CompareButton';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getComparisonCars,
  resetComparisonCars,
} from '@/store/reducers/cars-stock';
import { getComparisonCarsLink } from '@/modules/CarsStock/components/common.helpers';
import { media } from '@/utils/mixin';

function CompareButton() {
  const dispatch = useTypedDispatch();
  const comparisonCars = useTypedSelector(getComparisonCars);
  const comparisonCarsLink = getComparisonCarsLink(comparisonCars);

  if (comparisonCars.length === 0) {
    return null;
  }

  return (
    <Component>
      <CompareButtonComponent
        numberOfCompareCars={comparisonCars.length}
        link={comparisonCarsLink}
        onReset={() => dispatch(resetComparisonCars())}
      />
    </Component>
  );
}

export default CompareButton;

const Component = styled.div`
  z-index: 200;
  display: flex;
  justify-content: center;
  position: sticky;
  margin-top: 20px;
  bottom: 40px;

  ${media.tablet(css`
    display: block;
    bottom: 150px;
  `)}
`;
